import React from "react";

export const PERIOD_OPTIONS = [["0", "Today"], ["7", "7 days"], ["30", "30 days"], ["60", "60 days"], ["90", "90 days"]];
export const periodLabel = (days) => (String(days) === "0" ? "Today" : `Last ${days} days`);

export default function PeriodFilter({ value, onChange, testId = "period-filter" }) {
  return (
    <div className="inline-flex rounded-full border border-slate-200 bg-white p-1" role="tablist" data-testid={testId}>
      {PERIOD_OPTIONS.map(([v, label]) => (
        <button key={v} role="tab" aria-selected={String(value) === v} onClick={() => onChange(v)} data-testid={`${testId}-${v}`}
          className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors sm:px-3.5 ${String(value) === v ? "bg-[#4338CA] text-white" : "text-slate-500 hover:bg-slate-100 hover:text-slate-800"}`}>
          {label}
        </button>
      ))}
    </div>
  );
}
